import { render, staticRenderFns } from "./ReportTrafficAccidents.vue?vue&type=template&id=06efc912&"
import script from "./ReportTrafficAccidents.vue?vue&type=script&lang=js&"
export * from "./ReportTrafficAccidents.vue?vue&type=script&lang=js&"
import style0 from "./ReportTrafficAccidents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports